import * as S from "@dcspark/cardano-multiplatform-lib-nodejs";
export const CborDeserializableEntities = [
    S.Address,
    S.AssetName,
    S.AssetNames,
    S.Assets,
    S.AuxiliaryData,
    S.AuxiliaryDataHash,
    S.BigInt,
    S.BigNum,
    S.Bip32PrivateKey,
    S.Bip32PublicKey,
    S.Block,
    S.BlockBodyHash,
    S.BlockHeaderHash,
    S.BootstrapWitness,
    S.ByronAddress,
    S.Certificate,
    S.Certificates,
    S.ConstrPlutusData,
    S.CostModel,
    S.Costmdls,
    S.DNSRecordAorAAAA,
    S.DNSRecordSRV,
    S.DataHash,
    S.Ed25519KeyHash,
    S.Ed25519KeyHashes,
    S.Ed25519Signature,
    S.ExUnitPrices,
    S.ExUnits,
    S.GeneralTransactionMetadata,
    S.GenesisDelegateHash,
    S.GenesisHash,
    S.GenesisHashes,
    S.GenesisKeyDelegation,
    S.Header,
    S.HeaderBody,
    S.Int,
    S.Ipv4,
    S.Ipv6,
    S.KESSignature,
    S.KESVKey,
    S.Language,
    S.LegacyDaedalusPrivateKey,
    S.MIRToStakeCredentials,
    S.MetadataList,
    S.MetadataMap,
    S.Mint,
    S.MoveInstantaneousReward,
    S.MoveInstantaneousRewardsCert,
    S.MultiAsset,
    S.MultiHostName,
    S.NativeScript,
    S.NetworkId,
    S.Nonce,
    S.OperationalCert,
    S.PlutusData,
    S.PlutusList,
    S.PlutusMap,
    S.PlutusScript,
    S.PlutusV1Scripts,
    S.PlutusV2Scripts,
    S.PoolMetadata,
    S.PoolMetadataHash,
    S.PoolParams,
    S.PoolRegistration,
    S.PoolRetirement,
    S.ProposedProtocolParameterUpdates,
    S.ProtocolParamUpdate,
    S.ProtocolVersion,
    S.PublicKey,
    S.Redeemer,
    S.RedeemerTag,
    S.Redeemers,
    S.Relay,
    S.Relays,
    S.RewardAddresses,
    S.ScriptAll,
    S.ScriptAny,
    S.ScriptDataHash,
    S.ScriptHash,
    S.ScriptHashes,
    S.ScriptNOfK,
    S.ScriptPubkey,
    S.SingleHostAddr,
    S.SingleHostName,
    S.StakeCredentials,
    S.StakeDelegation,
    S.StakeDeregistration,
    S.StakeRegistration,
    S.TimelockExpiry,
    S.TimelockStart,
    S.Transaction,
    S.TransactionBodies,
    S.TransactionBody,
    S.TransactionHash,
    S.TransactionIndexes,
    S.TransactionInput,
    S.TransactionInputs,
    S.TransactionMetadatum,
    S.TransactionMetadatumLabels,
    S.TransactionOutput,
    S.TransactionOutputs,
    S.TransactionUnspentOutput,
    S.TransactionWitnessSet,
    S.TransactionWitnessSets,
    S.URL,
    S.UnitInterval,
    S.Update,
    S.VRFCert,
    S.VRFKeyHash,
    S.VRFVKey,
    S.Value,
    S.Vkey,
    S.Vkeywitness,
    S.Withdrawals,
];
export const CborSerializableEntities = CborDeserializableEntities;
//# sourceMappingURL=CborSerializableEntities.js.map